function Descending({ dimensions, col = '#000' }) {
  const baseXml = `
        <svg  width=${dimensions || '20'} height=${dimensions || '20'} viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 2.38419e-07H5.5V1.66667H0.5V2.38419e-07ZM0.5 10V8.33333H15.5V10H0.5ZM0.5 4.16667H10.5V5.83333H0.5V4.16667Z" fill=${`"${col}"`}/>
        </svg>`;

  return baseXml;
}

export default Descending;
